import React, { useState, useEffect } from "react";
import styled, { css } from "styled-components";
import { useLessonDetails } from "../../hooks/useLessonDetails";
import LessonData from "../LessonData";
import Button from "../Button";
import { sort, resolve } from "../../helpers/lessons";
import { useAttempt } from "../../hooks/useAttempt";

const LessonView = ({ id = undefined, userId = undefined }) => {
  const lesson = useLessonDetails(id);
  const lastAttempt = useAttempt(id, userId);

  const [seed, setSeed] = useState({ seed: undefined });

  const [showSolution, setShowSolution] = useState(false);

  useEffect(() => {
    if (!lesson?.data) return;
    setSeed({ seed: sort(lesson.data) });
  }, [id, lesson?.data]);

  return (
    <Container>
      {lastAttempt?.attempt > 0 && <Tag>Intento #{lastAttempt?.attempt}</Tag>}
      {lesson?.description && <Description>{lesson?.description}</Description>}
      {lesson && !lastAttempt && <LessonData seed={seed.seed} freeze={true} />}

      {lastAttempt && (
        <>
          <LessonData
            freeze
            seed={
              showSolution
                ? resolve(lastAttempt.seed, lastAttempt.data)?.data
                : lastAttempt.data
            }
          />
          {lastAttempt.state !== "SUCCESS" && (
            <>
              {showSolution ? (
                <ButtonSticky
                  text="Ver mi respuesta"
                  onClick={() => setShowSolution(false)}
                  opaque
                />
              ) : (
                <ButtonSticky
                  text="Ver solución"
                  onClick={() => setShowSolution(true)}
                  tertiary
                />
              )}
            </>
          )}
        </>
      )}

      {!lesson && <Spinner src="loading-blue.gif" />}
    </Container>
  );
};


const Container = styled.div`
  width: 100%;
`;

const Description = styled.div`
  font-size: 0.9em;
  color: white;
  margin-bottom: 25px;
`;

const ButtonSticky = styled(Button)`
  margin: 20px auto 0px auto;
  position: sticky;
  bottom: 0px;
  background: rgb(50, 176, 234);
  background: linear-gradient(
    0deg,
    rgba(50, 176, 234, 1) 0%,
    rgba(50, 176, 234, 0.6166841736694677) 30%,
    rgba(255, 255, 255, 0) 80%
  );
  padding: 5px 10px 8px 10px;

  .button {
    background-color: rgba(33, 150, 243, 0.85);
    color: white;
  }

  ${(props) =>
    props.opaque &&
    css`
      .button {
        background-color: rgba(0, 0, 0, 0.08);
        color: white;
      }
    `}
`;

// const ContainerState = styled.div`
//   padding: 20px;
//   & > * {
//     margin: 5px;
//   }
// `;

// const ButtonState = styled(Button)`
//   margin-top: 30px;
// `;

// const ModalStyled = styled(Modal)`
//   max-width: 220px;
//   width: 100%;
// `;

const Spinner = styled.img`
  margin: auto;
  width: 25px;
  height: 25px;
  display: block;
`;

const Tag = styled.div`
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 10px 10px;
  margin-bottom: 10px;
  font-size: 0.9em;
  font-weight: 600;
  margin: 0px 0px 25px 0px;
`;

export default LessonView;
